import { get, put } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';

export const actions = {
  get: get`settings/index-configuration/platform-details`(),
  put: put`settings/index-configuration/platform-details`(),
  getShopifyLocations: get`settings/shopify/locations`(),
};

export const reducer = createReducer(actions, {
  [`${actions.getShopifyLocations}`]: (
    state,
    { payload: { shopifyLocations } }
  ) => ({
    ...state,
    shopifyLocations,
  }),
});
